module.exports = __webpack_public_path__ + "img/62ac17077947467892a34b0caa2433a7-640.6485a4b2.png";